
// 资源库分享弹框
Vue.component("resource_share_modal", {
  data() {
      return {
          visible: false,
          resourceInfo: {},
          tabActive: '1',
          linkForm:{
              validity: 7,
              onlyRead: true,
              name:''
          },//分享链接表单
          userForm:{
              validity: 7,
              onlyRead: true,
              name:''
          },//分享用户表单
          rules:{
              name: [{ required: true, message: '主题不能为空', trigger: 'blur' }],
              teacher: [{ required: true, message: '请选择系统用户', trigger: 'blur' }]
          },//表单校验规则
          pager: {
              page:1,
              size:30,
              keyword:''
          },//分享用户翻页 xinxi
          loading: false,
          userOptions: [],//分享系统用户下拉列表
          shareLinkStatus: false,//链接分享成功状态
          shareUserStatus: false,//用户分享成功状态
          linkData: {},//分享链接数据
          clipboard:null,
          loading: false,
      };
  },
  directives:{
      loadData:{
              bind(el, binding) {
              // 获取element-ui定义好的scroll盒子
              const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
              SELECTWRAP_DOM.addEventListener('scroll', function() {
                  /**
                   * scrollHeight 获取元素内容高度(只读)
                   * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                   * clientHeight 读取元素的可见高度(只读)
                   * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                   * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                   */
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight
                  //监听下拉框是否滚动到底部，滚动到底部就加载下一页数据
                  if (condition) binding.value()
              })
          }
      }
  },
  methods: {
      open(resourceInfo) {
          this.visible = true
          //数据初始化
          this.resourceInfo = resourceInfo
          this.linkForm = {
              validity: 7,
              onlyRead: true,
              name:''
          }
          this.userForm = {
              validity: 7,
              onlyRead: true,
              name:''
          }
          this.linkForm.shareResourceInfos = [resourceInfo]
          this.userForm.shareResourceInfos = [resourceInfo]
          this.linkForm.name = resourceInfo.name
          this.userForm.name = resourceInfo.name
          this.pager = {
              page:1,
              size:30,
              keyword:''
          }
          this.shareLinkStatus = false
          this.shareUserStatus = false
          this.tabActive = '1'
          this.getData()
      },
      //获取用户列表数据
      getData(query) {
          this.loading = true
          if(query){
              this.pager.keyword = query
              this.pager.page = 1
              //筛选出已选项设置为不可见，以便选中状态展示
              let hasSelected = this.userOptions.filter(el=>this.userForm.teacher.includes(el.fieldCode)).map(el=>({...el,ifShow:false}))
              this.userOptions = [...hasSelected]
          }
          API.reqShareUserList(this.pager).then(res=>{
              if(res.errorCode == 'success' && res.extendMessage){
                  let formate = res.extendMessage.results.map(el=>({
                      ...el,
                      showValue:`${el.fieldValue}（${el.extendedValue}，${el.fieldCode}）`,
                      ifShow: true
                  }))
                  this.userOptions = this.userOptions.concat(formate)
              }
          }).finally(()=>{
              this.loading = false
          })
      },
      loadData() {
          // 防抖处理
          let timeout = null
          clearTimeout(timeout)
          timeout = setTimeout(() => {
              if (this.loading) return
              this.pager.page++
              this.getData()
          }, 500)
      },
      //确认分享
      handleConfirm(){
          const that = this
          if(this.tabActive == '1'){
              //分享链接
              this.$refs.linkForm.validate(valid=>{
                  if(!valid) return
                  that.loading = true
                  API.reqResourceShareLink(that.linkForm).then(res=>{
                      // debugger
                      if(res.success){
                          that.linkData = {
                              link:location.origin + '/rman/#/basic/shareDetail/' + res.data.link + (res.data.password? '_1': '_0'),
                          }
                          //漏洞扫描修改，放在对象里面会报漏洞
                          that.linkData.password = res.data.password
                          that.shareLinkStatus = true
                          that.$nextTick(()=>{
                              //初始化复制按钮事件
                              console.log(that.$refs.copy_link_btn)
                              that.clipboard = new ClipboardJS(that.$refs.copy_link_btn.$el, {
                                  text: ()=> this.$t('链接') + '：' + that.linkData.link + '     ' + that.$t('获取密码') +'：' + that.linkData.password
                              });
                              that.clipboard.on('success', function(e) {
                                  console.log(e)
                                  that.$message.success(that.$t('复制成功'))
                              });
                          })
                      }
                  }).finally(()=>that.loading = false)
              })
          }else{
              //分享系统用户
              this.$refs.userForm.validate(valid=>{
                  if(!valid) return
                  that.loading = true
                  that.userForm.shareUserInfos = that.userOptions.filter(el=>that.userForm.teacher.includes(el.fieldCode))
                      .map(el=>({shareUserCode:el.fieldCode,shareUserName:el.fieldValue}))
                  API.reqResourceShareUser(that.userForm).then(res=>{
                      if(res.success){
                          that.shareUserStatus = true
                      }
                  }).finally(()=>that.loading = false)
              })
          }
      },
      //关闭弹窗
      handleClose(){
          if(this.clipboard) {
              //销毁
              this.clipboard.destroy()
              this.clipboard = null
          }
          this.visible = false
      },
  },
  template: `
      <el-dialog :visible.sync="visible" class="resource_share_modal" title="" width="490px" @close="handleClose">
          <el-tabs v-model="tabActive">
              <el-tab-pane :label="$t('创建分享链接')" name="1"></el-tab-pane>
              <el-tab-pane :label="$t('分享给系统用户')" name="2"></el-tab-pane>
          </el-tabs>
          <!--分享链接-->
          <el-form v-show="tabActive == '1' && !shareLinkStatus" :model="linkForm" :rules="rules" ref="linkForm" label-width="100px">
            <el-form-item :label="$t('分享内容')">
              <span>{{resourceInfo.name}}</span>
            </el-form-item>
            <el-form-item :label="$t('分享主题')" prop="name">
               <el-input v-model="linkForm.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('分享有效期')">
              <el-radio-group v-model="linkForm.validity">
                <el-radio :label="7">7{{$t('天')}}</el-radio>
                <el-radio :label="30">30{{$t('天')}}</el-radio>
                <el-radio :label="-1">{{$t('永久有效')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('允许下载')">
              <el-radio-group v-model="linkForm.onlyRead">
                <el-radio :label="false">{{$t('是')}}</el-radio>
                <el-radio :label="true">{{$t('否')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('启用密码')">
              <el-switch v-model="linkForm.enablePassword"></el-switch>
            </el-form-item>
            <el-form-item v-if="linkForm.enablePassword" :label="$t('设置密码')" prop="linkPassword">
               <el-input v-model="linkForm.linkPassword" placeholder="自定义密码"></el-input>
               <span style="color: rgba(0, 0, 0, 0.45);font-size: 14px;line-height: 1.5715;">{{$t('注：如果不填，则系统自动生成')}}</span>
            </el-form-item>
          </el-form>
          <div v-show="tabActive == '1' && shareLinkStatus" style="line-height: 2;margin: 20px 0">
              <p>{{$t('链接')}}：{{linkData.link}}</p>
              <p>{{$t('获取密码')}}：{{linkData.password}}</p>
          </div>
          <!--分享给用户-->
          <el-form v-show="tabActive == '2' && !shareUserStatus" :model="userForm" :rules="rules" ref="userForm" label-width="100px">
            <el-form-item :label="$t('分享内容')">
              <span>{{resourceInfo.name}}</span>
            </el-form-item>
            <el-form-item :label="$t('分享主题')" prop="name">
               <el-input v-model="userForm.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('分享有效期')">
              <el-radio-group v-model="userForm.validity">
                <el-radio :label="7">7{{$t('天')}}</el-radio>
                <el-radio :label="30">30{{$t('天')}}</el-radio>
                <el-radio :label="-1">{{$t('永久有效')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('允许下载')">
              <el-radio-group v-model="userForm.onlyRead">
                <el-radio :label="false">{{$t('是')}}</el-radio>
                <el-radio :label="true">{{$t('否')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('分享给')" prop="teacher">
               <el-select
                  v-model="userForm.teacher"
                  v-loadData="loadData"
                  remote
                  filterable
                  :remote-method="getData"
                  multiple="multiple"
                  clearable="clearable"
                  :placeholder="$t('请选择系统用户')"
                  class="more-select resource_user_select"
                >
                  <!-- 只有isShow定义了false，才进行隐藏，否则正常显示 -->
                  <el-option
                    v-for="item,i in userOptions"
                    v-show="item.ifShow != false"
                    :key="i"
                    :label="item.showValue"
                    :value="item.fieldCode"
                  />
                </el-select>
            </el-form-item>
          </el-form>
          <div v-show="tabActive == '2' && shareUserStatus" style="margin: 20px 0;text-align: center">{{$t('分享成功')}}</div>
          <div slot="footer">
              <el-button type="primary" @click="handleConfirm" v-if="tabActive == '1' && !shareLinkStatus" :loading="loading">{{$t('创建分享链接')}}</el-button>
              <el-button type="primary" v-if="tabActive == '1' && shareLinkStatus" ref="copy_link_btn">{{$t('复制链接及密码')}}</el-button>
              <el-button type="primary" @click="handleConfirm" v-if="tabActive == '2' && !shareUserStatus" :loading="loading">{{$t('分享')}}</el-button>
              <el-button type="primary" @click="handleClose" v-if="tabActive == '2' && shareUserStatus">{{$t('完成')}}</el-button>
          </div>
      </el-dialog>
  `,
});